import { useQuery } from "@tanstack/react-query";

import { FplConstantsApi } from "../api/fplConstantsApi";

export const FplConstantsQueryKeys = {
  all: ["fplConstants"] as const,
  byYear: (year: number) =>
    [...FplConstantsQueryKeys.all, "byYear", year] as const,
};

export const useGetFplConstantsByYearQuery = (year?: number) => {
  return useQuery({
    queryKey: FplConstantsQueryKeys.byYear(year ?? 0),
    queryFn: () => FplConstantsApi.getFplConstantsByYear(year ?? 0),
    enabled: Boolean(year),
  });
};
